import { useMemo } from 'react'

import { toUsdString } from 'pared/utils/number'

import {
  fwWingstopCheckAvgDayPartConfigs,
  fwWingstopChecksDayPartConfigs,
  fwWingstopSalesDayPartConfigs,
  useFwWingstopDayPartCheckAvg,
  useFwWingstopDayPartChecks,
  useFwWingstopDayPartSales,
} from '../../tableV2/hooks/fwWingstop/useDayPartOrderMode'

export const fwWingstopDayPartOrderModeConfigs = {
  ...fwWingstopSalesDayPartConfigs,
  ...fwWingstopChecksDayPartConfigs,
  ...fwWingstopCheckAvgDayPartConfigs,
} as const

const useFwWingstopDayPartOrderMode = () => {
  const { data: salesData, loading: salesLoading } = useFwWingstopDayPartSales()
  const { data: checksData, loading: checksLoading } =
    useFwWingstopDayPartChecks()
  const { data: checkAvgData, loading: checkAvgLoading } =
    useFwWingstopDayPartCheckAvg()

  const loading = salesLoading || checksLoading || checkAvgLoading

  return useMemo(() => {
    if (!salesData || !checksData || !checkAvgData)
      return {
        source: null,
      }

    return {
      data: {
        source: [
          ...salesData.map((d) => ({
            ...d,
            dayPart: `Sales - ${d.dayPart}`,
            valueForDateRange1InPast: toUsdString(
              (d.valueForDateRange1InPast as number) / 100,
              0,
            ),
            valueForDateRange2InPast: toUsdString(
              (d.valueForDateRange2InPast as number) / 100,
              0,
            ),
            valueForDateRange3InPast: toUsdString(
              (d.valueForDateRange3InPast as number) / 100,
              0,
            ),
            valueForDateRange4InPast: toUsdString(
              (d.valueForDateRange4InPast as number) / 100,
              0,
            ),
          })),
          ...checksData.map((d) => ({
            ...d,
            dayPart: `Checks - ${d.dayPart}`,
            valueForDateRange1InPast: d.valueForDateRange1InPast
              ? (d.valueForDateRange1InPast as number).toLocaleString('en-US')
              : null,
            valueForDateRange2InPast: d.valueForDateRange2InPast
              ? (d.valueForDateRange2InPast as number).toLocaleString('en-US')
              : null,
            valueForDateRange3InPast: d.valueForDateRange3InPast
              ? (d.valueForDateRange3InPast as number).toLocaleString('en-US')
              : null,
            valueForDateRange4InPast: d.valueForDateRange4InPast
              ? (d.valueForDateRange4InPast as number).toLocaleString('en-US')
              : null,
          })),
          ...checkAvgData.map((d) => ({
            ...d,
            dayPart: `Check Avg - ${d.dayPart}`,
            valueForDateRange1InPast: d.valueForDateRange1InPast
              ? (d.valueForDateRange1InPast as number).toLocaleString('en-US')
              : null,
            valueForDateRange2InPast: d.valueForDateRange2InPast
              ? (d.valueForDateRange2InPast as number).toLocaleString('en-US')
              : null,
            valueForDateRange3InPast: d.valueForDateRange3InPast
              ? (d.valueForDateRange3InPast as number).toLocaleString('en-US')
              : null,
            valueForDateRange4InPast: d.valueForDateRange4InPast
              ? (d.valueForDateRange4InPast as number).toLocaleString('en-US')
              : null,
          })),
        ],
      },
      loading,
    }
  }, [salesData, checksData, checkAvgData, loading])
}

export default useFwWingstopDayPartOrderMode
